import { Suspense } from 'react';

import { getCountry } from '@iwIntlProvider/CountryProvider';

import styles from './Navigation.module.css';
import { OpenBankingStatus } from '../../dataHelpers/OnlineAccounts/getOpenBankingStatus';
import { ErrorBoundary } from '../../errorBoundary/ErrorBoundary';
import { BankSelectionModal } from '../modals/BankSelectionModal/BankSelectionModal';
import { useOpenBankingEntry } from '../modals/BankSelectionModal/useOpenBankingEntry';
import { BankIconWithDot } from '../ui/OpenBankingStatusIndicator/BankIconWithDot';

type IconStatus = 'active' | 'expiring' | 'expired';

const ICON_STATUS: Record<OpenBankingStatus, IconStatus> = {
    disconnected: 'expired',
    expired: 'expired',
    expiring: 'expiring',
    connected: 'active'
};

export const OpenBankingNavAction = () => {
    if (getCountry() !== 'UK') return null;

    return (
        <ErrorBoundary fallback={() => null}>
            <Suspense fallback={null}>
                <OpenBankingNavActionContent />
            </Suspense>
        </ErrorBoundary>
    );
};

const OpenBankingNavActionContent = () => {
    const { status, openModal, modalProps } = useOpenBankingEntry('nav_icon');
    const iconStatus = ICON_STATUS[status];

    return (
        <>
            <button
                type="button"
                onClick={openModal}
                aria-label={`Open banking status: ${iconStatus}`}
                className={`${styles.rightAction} relative inline-flex items-end border-none bg-transparent p-0`}
            >
                <span className="size-[20px]">
                    <BankIconWithDot status={iconStatus} />
                </span>
            </button>
            <BankSelectionModal {...modalProps} />
        </>
    );
};
